/* eslint-disable no-underscore-dangle */
export const remove = (db, key, onRemove = () => {}) => db
  .get(key)
  .then((doc) => db.remove(key, doc._rev, [], onRemove))
  .then()
  .catch(() => {});

export const upsert = (db, key, data, onUpsert = () => {}) => db
  .get(key)
  .then((doc) => db.put({ _id: key, ...data, _rev: doc._rev }, onUpsert))
  .then()
  .catch(() => db.put({ _id: key, ...data }, onUpsert));

export const bulkUpsert = (db, data, onUpsert = () => {}) => {
  db.bulkDocs(data.map((d) => ({ ...d, id: d.id }))).then(onUpsert);
};

export const getAllWithDocs = ({ db, callback }) => db
  .allDocs({ include_docs: true })
  .then((doc) => {
    callback(doc.rows.map((r) => r.doc));
  })
  .then(() => {})
  .catch(() => {
    callback();
  });

export const get = ({ key, db, callback }) => db
  .get(key)
  .then((doc) => {
    callback(doc);
  })
  .then(() => {})
  .catch(() => {
    callback();
  });
